import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken, getImprove } from '@/utils/auth' // 验权
import Cookies from 'js-cookie'
import { heartCheck } from '@/api/login'
import i18n from './lang' // Internationalization

if (getToken()) {
  heartCheck()
}
const whiteList = ['/login', '/reset-pwd', '/SSO', '/impove-pwd', '/register', '/ExtLogin', '/anonymous', '404'] // 不重定向白名单
const extendWhiteList = ['/SSO', '/ExtLogin', '/anonymous', '/reset-pwd', '/register']
const whiteListMatch = (path) => {
  let matched = false
  whiteList.forEach(item => {
    if (matched) {
      return
    }
    if (path.indexOf(item) >= 0) {
      matched = true
    }
  })
  return matched
}
const extendWhiteListMatch = (path) => {
  let matched = false
  extendWhiteList.forEach(item => {
    if (matched) {
      return
    }
    if (path.indexOf(item) >= 0) {
      matched = true
    }
  })
  return matched
}
const setSidParam = (from, to) => {
  if (extendWhiteListMatch(to.path)) {
    return undefined
  }
  if (to.path.indexOf('/login') >= 0) {
    return undefined
  }
  if (to.query && to.query.sid) {
    return undefined
  }
  if (from.query && from.query.sid) {
    return to.path + (to.path.indexOf('?') >= 0 ? '&sid=' : '?sid=') + from.query.sid
  } else {
    return `/login?redirect=${to.path}`
  }
}
const getSid = (from) => {
  if (from.query && from.query.sid) {
    return from.query.sid
  }
  const lastSolution = localStorage.getItem('client-solutionId')
  if (lastSolution) {
    return lastSolution.split('-')[0]
  }
  var solutionList = localStorage.getItem('solution-list')
  if (solutionList) {
    try {
      solutionList = JSON.parse(solutionList)
      if (solutionList.length) {
        return solutionList[0].id.split('-')[0]
      }
    } catch (ex) {
      return ''
    }
  }
  return ''
}
router.beforeEach((to, from, next) => {
  NProgress.start()
  console.log(extendWhiteListMatch(to.fullPath))
  if (getToken() && !extendWhiteListMatch(to.fullPath)) {
    console.log('有token')
    if (eval(getImprove())) { // 密码策略未通过
      if (whiteListMatch(to.path)) {
        next(setSidParam(from, to))
      } else {
        next(`/login?redirect=${to.path}&sid=${getSid(from)}`) // 否则全部重定向到登录页
        // NProgress.done()
      }
    } else {
      var fillInfo = localStorage.getItem('fillInfo')
      if (fillInfo) {
        fillInfo = JSON.parse(fillInfo)
        // 判断匿名填报处理
        if (to.path.indexOf(`/report/${fillInfo.Owner}/0`) < 0) {
          store.dispatch('FedLogOut').then(() => {
            localStorage.removeItem('fillInfo')
            window.location.href = window.location.origin
            Message.error(i18n.t('login.fedLogOut'))
          })
        } else {
          next(setSidParam(from, to))
          // NProgress.done()
        }
      } else {
        if (to.path === '/login') {
          next({ path: '/?sid=' + getSid(from) })
          // NProgress.done()
        } else if (to.path === '/reset-pwd') {
          next({ path: '/reset-pwd?sid=' + getSid(from) })
          // NProgress.done()
        } else if (to.path === '/manage') {
          if (store.state.user.permission.indexOf(5) === -1) {
            next({ path: '/?sid=' + getSid(from) })
            // NProgress.done()
          } else {
            next(setSidParam(from, to))
            // NProgress.done()
          }
        } else {
          if (from.path === '/' && to.path === '/dashboard') {
            store.dispatch('delAllViews')
            localStorage.removeItem('lastTab')
          }
          if (store.getters.userId === 0) {
            store.dispatch('GetInfo').then(res => { // 拉取用户信息
              next(setSidParam(from, to))
            }).catch(() => {
              store.dispatch('FedLogOut').then(() => {
                window.location.href = window.location.origin
                Message.error(i18n.t('login.fedLogOut'))
              })
            })
          } else {
            next(setSidParam(from, to))
          }
        }
      }
    }
  } else {
    console.log('无token')
    if (whiteListMatch(to.path)) {
      next(setSidParam(from, to))
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      // NProgress.done()
    }
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
